import { render, staticRenderFns } from "./MessageAddUsers.vue?vue&type=template&id=21f98b08"
import script from "./MessageAddUsers.vue?vue&type=script&lang=js"
export * from "./MessageAddUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports